import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Spinner } from './Spin/Spin';

var spinOpts = {
  lines: 13,
  // The number of lines to draw
  length: 38,
  // The length of each line
  width: 17,
  // The line thickness
  radius: 45,
  // The radius of the inner circle
  scale: 1,
  // Scales overall size of the spinner
  corners: 1,
  // Corner roundness (0..1)
  color: '#ffffff',
  // CSS color or array of colors
  fadeColor: 'transparent',
  // CSS color or array of colors
  speed: 1,
  // Rounds per second
  rotate: 0,
  // The rotation offset
  animation: 'spinner-line-fade-quick',
  // The CSS animation name for the lines
  direction: 1,
  // 1: clockwise, -1: counterclockwise
  zIndex: 2,
  // The z-index (defaults to 2000000000)
  className: 'spinner',
  // The CSS class to assign to the spinner
  top: '50%',
  // Top position relative to parent
  left: '50%',
  // Left position relative to parent
  shadow: '0 0 1px transparent',
  // Box-shadow for the lines
  position: 'absolute',
  // Element positioning
  lineColorClass: 'spinner-line-background-color'
};

var CommonLoad = /*#__PURE__*/function (_Component) {
  _inherits(CommonLoad, _Component);

  var _super = _createSuper(CommonLoad);

  function CommonLoad(props) {
    var _this;

    _classCallCheck(this, CommonLoad);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "container", void 0);

    _defineProperty(_assertThisInitialized(_this), "spinner", void 0);

    _defineProperty(_assertThisInitialized(_this), "updateSpinning", function () {
      var spinning = _this.props.spinning;
      var currentSpinning = _this.state.spinning;

      if (currentSpinning !== spinning) {
        _this.setState({
          spinning: spinning
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderSpin", function () {
      var spinning = _this.state.spinning;
      var _this$props = _this.props,
          wrapStyle = _this$props.wrapStyle,
          size = _this$props.size,
          left = _this$props.left,
          top = _this$props.top;
      if (size) spinOpts.scale = size;
      if (left) spinOpts.left = left;
      if (top) spinOpts.top = top;
      var spinElement = /*#__PURE__*/React.createElement("div", {
        ref: _this.container,
        style: wrapStyle
      });
      var containerChild = spinning ? 'opacity0' : 'opacity1';

      if (_this.isNestedPattern()) {
        return /*#__PURE__*/React.createElement("div", {
          className: spinning ? 'nested-loading-container' : ''
        }, spinning && /*#__PURE__*/React.createElement("div", {
          key: "loading",
          className: "nested-loading"
        }, spinElement), /*#__PURE__*/React.createElement("div", {
          key: "container",
          className: containerChild
        }, _this.props.children));
      }

      return spinElement;
    });

    _this.state = {
      spinning: _this.props.spinning,
      indicator: _this.props.indicator,
      wrapStyle: _this.props.wrapStyle
    };
    _this.container = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(CommonLoad, [{
    key: "isNestedPattern",
    value: function isNestedPattern() {
      return !!(this.props && this.props.children);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateSpinning();
      this.spinner = new Spinner(spinOpts);
      this.spinner.spin(this.container.current);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.spinner.stop();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.spinner) {
        this.spinner.stop();
      }

      this.spinner = new Spinner(spinOpts);
      this.spinner.spin(this.container.current);
      this.updateSpinning();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.renderSpin());
    }
  }]);

  return CommonLoad;
}(Component);

_defineProperty(CommonLoad, "defaultProps", {
  spinning: true,
  indicator: '/images/eclipse-loader.svg',
  size: 0.5,
  left: '50%',
  top: '50%',
  wrapStyle: {}
});

export default CommonLoad;